import React from 'react';
import { X, ArrowLeft } from 'lucide-react';
import { useScrollLock } from '../hooks/useScrollLock.js';
import { useI18n } from '../i18n/index.jsx';

export const Modal = ({
  children,
  onClose,
  onBack,
  className = '',
  headerClassName = '',
  contentClassName = '',
  style,
}) => {
  // Lock body scroll when modal is open
  useScrollLock(true);
  const { t } = useI18n();

  return (
    <div className={`modal ${className}`} style={style}>
      <div className="modal__overlay" onClick={onClose} />
      <div className="modal__container">
        {/* Header Navigation */}
        <div className={`modal__header ${headerClassName}`}>
          <button className="modal__back-btn" onClick={onBack} aria-label={t('go_back')}>
            <ArrowLeft size={18} className="sb-flip-rtl" />
            <span className="modal__back-text">{t('back')}</span>
          </button>

          <button className="modal__close-btn" onClick={onClose} aria-label={t('close_modal')}>
            <X />
          </button>
        </div>

        {/* Content Area */}
        <div className={`modal__content ${contentClassName}`}>{children}</div>
      </div>
    </div>
  );
};
